import { onError } from '@apollo/client/link/error/index.js';
import { dev } from '$app/environment';
import { captureException } from '@sentry/sveltekit';

export const errorLink = () =>
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) => {
        if (!dev) {
          captureException(
            new Error(`[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`)
          );
        } else {
          console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
        }
      });
    if (networkError && dev) {
      console.error('[Network error]:', networkError);
    }
  });
